export const actions = {
  get_reservations: 'get_reservations',
  get_lodging_types: 'get_lodging_types',
  get_lodging: 'get_lodging',
  get_business: 'get_business',
  get_announcements: 'get_announcements',
  get_images: 'get_images',
}